import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current_header_step: "START",
};

export const personalCyberFormSlice = createSlice({
    name: "personal_cyber_form_slice",
    initialState,
    reducers: {
        setPersonalCyberFormData: (state, action) => {
            let { form_name, data } = action.payload || {};
            state[form_name] = data;
        },
        clearPersonalCyberFormData: (state, action) => {
            const { form_name } = action.payload || {};
            if (form_name) {
                state[form_name] = null;
            }
        },

        // header step
        setPersonalCyberFormHeaderStep: (state, action) => {
            let stepType = action.payload;
            state.current_header_step = stepType;
        },

        clearNewPersonalCyberFormData: () => initialState

    }
});

// SELECTORS
export const selectPersonalCyberForm = (store) => store?.personalCyberFormData;
export const selectPersonalCyberFormHeaderStep = (store) => store?.personalCyberFormData?.current_header_step;

// ACTIONS 
export const { 
    setPersonalCyberFormData, 
    clearPersonalCyberFormData, 
    setPersonalCyberFormHeaderStep, 
    clearNewPersonalCyberFormData 
} = personalCyberFormSlice.actions;

export default personalCyberFormSlice.reducer;